/** Total fetch/decode budget. Keep the longer window limited to these authored instructor models. */
export const FITNESS_ASSET_TIMEOUT_MS = 14_000;
export const FITNESS_INSTRUCTOR_ASSET_TIMEOUT_MS = 60_000;
const INSTRUCTOR_MODELS = new Set([
  '/fitness/instructors/v12/male-sport.glb',
  '/fitness/instructors/v12/female-sport.glb',
  '/fitness/instructors/v13/male-sport.glb',
  '/fitness/instructors/v13/female-sport.glb',
  '/fitness/instructors/v14/male-sport.glb',
  '/fitness/instructors/v14/female-sport.glb',
]);

export function fitnessAssetTimeoutMs(url: string): number {
  // A 14 MB first download takes about 28 seconds at 4 Mbps, before parsing.
  return INSTRUCTOR_MODELS.has(url) ? FITNESS_INSTRUCTOR_ASSET_TIMEOUT_MS : FITNESS_ASSET_TIMEOUT_MS;
}
